import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
// import convert from '../../helpers/convert'
import format from '../../helpers/format'
import Styles from './AutocompleteSearch.css'
// import {SlideDown} from 'react-slidedown'
// import ReactTooltip from 'react-tooltip'
import config from '../../config'
import {
  // Grade,
  // Link,
  // LinkIcon,
  SrOnly
} from '../../components'

import {Row, Col} from 'react-flexbox-grid'
import Autosuggest from 'react-autosuggest'
import { connect } from 'react-redux'
import * as searchActions from 'redux/modules/search'
import Loader from 'react-loader'


function getSelectedSuggestion( selectedSuggestion, suggestions, method ) {
  if( method !== 'up' && method !== 'down' ){
    return selectedSuggestion
  }
  let inc = null;
  if( method === 'up' ){
    if( selectedSuggestion === null ) return (suggestions.length-1)
    inc = -1;
  } else if ( method === 'down' ) {
    if( selectedSuggestion === null ) return 0
    inc = 1;
  }
  selectedSuggestion =  selectedSuggestion + inc
  selectedSuggestion =  ( selectedSuggestion < 0 || selectedSuggestion >= suggestions.length ) ? null : selectedSuggestion
  return selectedSuggestion
}

@connect(
  state => ({
    result: state.search.result,
    searching: state.search.loading,
    searched: state.search.loaded,
    error: state.search.error,
  }),
  searchActions)
@CSSModules(Styles,{allowMultiple:true})
export default class AutocompleteSearch extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    search: PropTypes.func
  }

  static contextTypes =  {
    router: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      value: '',
      selectedSuggestion: null,
      suggestions: [],
      onHovers: {},
      notFound: false,
      searchReq: null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if ( nextProps.result && nextProps.result.results && this.state.searchReq === nextProps.result.req ){
      let state = {
        suggestions: nextProps.result.results || []
      }
      if( nextProps.result && nextProps.result.results.length === 0 ){
        state = Object.assign({}, state, {
          notFound: true
        })
      }
      this.setState(state)
    }
  }

  onSuggestionsFetchRequested = ({ value, reason  }) => {
    if ( !value || value.length < 2 ) {
      this.setState({
        suggestions: [],
        notFound: false
      })
      return
    }
    this.setState({ selectedSuggestion:null })
    this.handleSearch(value)
  }

  onMouseEnter = (prop) => {
    return () => {
      // this.state.onHovers[prop] = true
      const onHovers = Object.assign({},this.state.onHovers)
      onHovers[prop] = true
      this.setState({onHovers: onHovers})
      // console.log('enter:',onHovers )
    }
  }

  onMouseLeave = (prop) => {
    return () => {
      const onHovers = Object.assign({},this.state.onHovers)
      delete onHovers[prop]
      this.setState({onHovers: onHovers})
      // console.log('leave:',onHovers )
      // console.log('leave:',this.state.onHovers )
    }
  }
  onChange = (event, { newValue, method }) => {
    const selectedSuggestion = getSelectedSuggestion( this.state.selectedSuggestion, this.state.suggestions, method )
    this.setState({
      value: newValue,
      selectedSuggestion: selectedSuggestion
    })
  }

  onKeyUp =  (event, data) => {
    if( event.key === 'Enter' && this.suggestionSelected === false ){
      this.onSubmit()
    }
  }

  onSubmit = () =>{
    this.context.router.push({
      pathname: '/funds',
      query: { q : this.state.value }
    })
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, sectionIndex, method }) => {
    // need a way to suppress the keyup enter event, dont want to push twice to the router
    this.suggestionSelected = true
    const name = format.sanitize(suggestion.fund_legal_name)
    const ticker = suggestion.ticker ? suggestion.ticker : 'N'
    const { fund_id, investment_vehicle_id } = suggestion
    let pathSegment = null
    switch (config.app.title) {
      case 'Fossil Free Funds':
        pathSegment = 'fossil-fuel-investments'
        break
      case 'Deforestation Free Funds':
        pathSegment = 'profile'
        break
      case 'Tobacco Free Funds':
        pathSegment = 'tobacco-profile'
        break
      case 'Weapon Free Funds':
        pathSegment = 'weapon-investments'
        break
      case 'Gender Equality Funds':
        pathSegment = 'gender-lens-score'
        break
      case 'Gun Free Funds':
        pathSegment = 'gun-investments'
        break
      case 'Prison Free Funds':
        pathSegment = 'prison-industrial-complex-investments'
        break
      default:
        pathSegment = 'profile'
        break
    }

    const path = `/fund/${name}/${ticker}/${pathSegment}/${fund_id}/${investment_vehicle_id}`
    this.context.router.push({ pathname: path })
  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
      notFound: false
    })
  }

  getSuggestionValue = (suggestion) => {
    // when suggestion selected, this function tells
    // what should be the value of the input
    return suggestion.name ? suggestion.name : (suggestion.fund_legal_name ? suggestion.fund_legal_name : this.state.value)
  }

  suggestionSelected = false
  lastHandleSearch = null

  handleSearch = (name) => {
    // add a delay
    const time = (new Date()).getTime()
    this.lastHandleSearch = time
    setTimeout(() => {
      // if time hasnt been update then hit search
      if( time === this.lastHandleSearch ){
        this.setState({searchReq: name})
        this.props.searchFunds(name)
      }
    }, 100);
  }

  renderSuggestion = (suggestion, {value,valueBeforeUpDown}) => {
    // console.log('render:',suggestion )
    return (
      <Row styleName='suggestion-row'>
        <Col xs={6} styleName='suggestion-name'>{suggestion.name}</Col>
        <Col xs={3} styleName='suggestion-ticker'>{suggestion.ticker}</Col>
        <Col xs={3} styleName='suggestion-family'>{suggestion.fund_family_name}</Col>
      </Row>
    )
  }

  render(){
    const { value, suggestions } = this.state
    const inputProps = {
      id: 'search',
      name: 'search',
      title: 'search',
      placeholder: 'Search funds by name, ticker, or manager',
      value,
      onChange: this.onChange,
      onKeyUp: this.onKeyUp
    }

    return (
      <div styleName='autocomplete-submit'>
        <label htmlFor='search'><SrOnly>Search</SrOnly></label>
        <Autosuggest
          theme={Styles}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={CSSModules(this.renderSuggestion,Styles)}
          onSuggestionSelected={this.onSuggestionSelected}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          inputProps={inputProps}
        />
        { (this.props.searching) ? (
            <div styleName='submit'>
              <Loader options={{scale: 0.50, top:'50%'}} />
            </div>
          ) : (
            <div
              styleName='submit'
              onClick={this.onSubmit}
              className='fa fa-search'
              title='Submit search'
            />
          ) }
        { (this.state.notFound) ? (
            <div styleName='autocomplete-notfound-wrap'>
              <div styleName='autocomplete-notfound'>
                Sorry, no results found
              </div>
            </div>
          ) : null  }
      </div>
    )
  }
}
